import {selectAllNodes, selectNode} from './helpers';
import {removeFromCart} from './small-cart';
import {addToCart} from './cart';

//Add cart text to cart-item data
function submitCardText (card) {
  const id = card.dataset.id;
  const key = card.dataset.key;
  const text = card.value;

  return jQuery.ajax({
    url: window.sharedResources.ajaxurl,
    type: 'POST',
    data: {
      action: 'submit-cart-text',
      id,
      key,
      text
    } 
  })
}

// handle change of product quantity
const handleQtyChange = (totalNode) => (row) => {
  const input = selectNode('table-qty-input', row);
  const rowTotal = selectNode('table-row-total', row);
  const {price, key, currency} = input.dataset;

  
  const submitChange = () => {
    input.classList.add('disabled');
    addToCart([{key, qty: input.value}], true);
  };

  const recalculateData = ({customData}) => {
    const {cart_total, line_total} = customData;

    if (line_total.cart_key !== key) return;

    totalNode.innerHTML = cart_total;
    input.value = line_total.quantity;
    rowTotal.innerHTML = `${price * line_total.quantity} ${currency}`;

    input.classList.remove('disabled');
  }

  input.addEventListener('blur', submitChange);
  document.addEventListener('product-submited', recalculateData);
}

// card text change handler and submit wc session
export function handleCardTextChange (cardTextInputs) {

  const handleCardTextChange = (card) => {
    let prevValue = card.innerHTML;

    return async function (e) {
      // card.classList.remove('expanded');
      
      if (prevValue != card.value) {
        card.classList.add('disabled');
        const result = await submitCardText(card);
        prevValue = result;
        card.innerHTML = result;
        card.classList.remove('disabled');
      }
    };
  }
  const expandCardTxt = (card) => (e) => card.classList.add('expanded');

  
  cardTextInputs.map(card => {
    card.addEventListener('blur', handleCardTextChange(card));
    // card.addEventListener('focus', expandCardTxt(card));
  });
}

export default function cartPage () {
  const removeBtns = selectAllNodes('wa-main-cart__remove');
  const cartTotal = selectNode('cart-total-result');
  const cardTextInputs = selectAllNodes('additional-input');
  const tableRows = selectAllNodes('wa-main-cart__table-row');


  removeBtns.map(btn => btn.addEventListener('click', removeFromCart(btn, cartTotal)));

  if (cardTextInputs.length) handleCardTextChange(cardTextInputs);

  tableRows.map(handleQtyChange(cartTotal));
}